/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { OppsummeringTo } from '../models/oppsummering-to';


/**
 * Resultat-API
 */
@Injectable({
  providedIn: 'root',
})
export class ResultatService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getResultat
   */
  static readonly GetResultatPath = '/oppsummering/{id}';

  /**
   * Henter et resultat med tilhørende tiltak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getResultat()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResultat$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<OppsummeringTo>> {

    const rb = new RequestBuilder(this.rootUrl, ResultatService.GetResultatPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OppsummeringTo>;
      })
    );
  }

  /**
   * Henter et resultat med tilhørende tiltak.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getResultat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResultat(params: {
    id: string;
  },
  context?: HttpContext

): Observable<OppsummeringTo> {

    return this.getResultat$Response(params,context).pipe(
      map((r: StrictHttpResponse<OppsummeringTo>) => r.body as OppsummeringTo)
    );
  }

}
